import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '@big-direkt/utils/environment';
import { MeiliSearch } from 'meilisearch';
import { type GeoDataResource } from '../models/geodata.resource';
import { type LocationsModelResource } from '../models/locations.model';

@Injectable({
    providedIn: 'root',
})
export class GeodataService {
    private readonly environment = inject(EnvironmentService);
    private readonly client;
    private readonly geoIndex = 'geodata';

    public constructor() {
        this.client = new MeiliSearch({
            host: this.environment.baseHref,
        });
    }

    public async getLocations(adressQuery: string): Promise<LocationsModelResource[]> {
        const response = await this.client.index(this.geoIndex).search<GeoDataResource>(adressQuery);

        return response.hits.map<LocationsModelResource>(hit => ({
            zipcode: hit.POSTLEITZAHL,
            city: hit.ORT_NAME,
            district: hit.GEMEINDE_NAME,
            geo: {
                lat: hit.ORT_LAT,
                lng: hit.ORT_LON,
            },
        }));
    }
}
